<div class="content-container mx-auto my-4">
    <h1 class="mt-0">My Permits</h1>

    @if (error) {
        <div class="alert alert-danger" role="alert">{{ error }}</div>
    }
    @if (loading) {
        <ngxh6-loading-or-error></ngxh6-loading-or-error>
    } @else if (needsEmail) {
        <!-- No proof on this device yet: the mailbox is what identifies the applicant. -->
        @if (sent) {
            <div class="alert alert-success" role="alert">
                <h2 class="h6 mt-0">Check your email</h2>
                <p class="mb-0">If that address has permits with us, we've sent it a link to view them. The link works for the next 12 hours.</p>
            </div>
        } @else {
            <p class="text-muted">Enter the email address you used on your application and we'll send you a link to all of your permits.</p>
            <!-- One line: this is a single question with a single answer, and stacking a
         full-width field over a button made it look like the start of a form. -->
            <form (ngSubmit)="requestLink()">
                <label class="form-label" for="find-email">Email address</label>
                <div class="d-flex flex-wrap align-items-start gap-2">
                    <input id="find-email" name="email" type="email" class="form-control find-email" [(ngModel)]="email" autocomplete="email" required />
                    <button type="submit" class="btn btn-primary ms-0 flex-shrink-0" [disabled]="!email || sending">
                        {{ sending ? 'Sending…' : 'Email me a link' }}
                    </button>
                </div>
            </form>
        }
    } @else if (!permits.length) {
        <p class="text-muted">You don't have any permits yet. <a routerLink="/find">Apply for a permit</a>.</p>
    } @else {
        @if (accountEmail) {
            <p class="text-muted small">Permits for {{ accountEmail }}</p>
        }
        <div class="table-responsive">
            <table class="table table-hover align-middle">
                <thead>
                    <tr>
                        <th>Type</th>
                        <th>Dates</th>
                        <th>Status</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>
                <tbody>
                    @for (permit of permits; track permit.token) {
                        <tr>
                            <td>{{ permit.permitType }}</td>
                            <td class="text-nowrap">
                                @if (permit.accessStartDate) {
                                    {{ permit.accessStartDate }} → {{ permit.accessEndDate }}
                                } @else {
                                    -
                                }
                            </td>
                            <td><app-permit-status-badge [status]="permit.status" [upcoming]="!!permit.upcoming"></app-permit-status-badge></td>
                            <td class="text-end"><a class="btn btn-sm btn-primary" [routerLink]="['/permit', permit.token]">View</a></td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>

        <p class="text-muted small mt-3 mb-0">
            This device remembers you for a short time so you don't have to re-enter your email.
            <button type="button" class="btn btn-link btn-sm p-0 align-baseline" (click)="forgetDevice()">Forget me on this device</button>
        </p>
    }
</div>
